<template>
    <div>
        <div  class="page-container">
            <div v-if="item.sourceType != 2" @click="getDetailByVisitingNo(item.visitingNo)" class="medical-box" v-for="(item,index) in data" :key="index">

                <div class="medical-inspect">
                    <div class="line">
                       <div>
                           <span class="label">就诊科室：</span>
                           <span>{{item.departmentName}}</span>
                       </div>
                        <span>{{getStatusName(item.visitingType)}}</span>
                    </div>
                    <div class="line">
                        <div>
                            <span class="label">时间：</span>
                            <span>{{item.visitingDate}}</span>
                        </div>
                        <span></span>
                    </div>

                    <!--<div class="noLine">-->
                    <!--<span class="label">检查报告：</span>-->
                    <!--<span v-if="item.reportList&& item.reportList.length>0">-->
                    <!--<b v-if="_item" v-for=" _item in item.reportList">{{_item}}</b>-->
                    <!--</span>-->
                    <!--<span v-else>-->
                    <!--无-->
                    <!--</span>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import {RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail} from  "@src/assets/js/api.js";
    export default {
        name:'PatientInHospitalList',
        data() {
            return {
                arr:["1","2","3","4"],
                show: 'showList',
                reportDetail: {}
            }
        },
        props:{
            data:{
                type:[Array,Object],
                default(){
                    return [];
                }
            },
        },
        components: {

        },
        methods:{
            getStatusName(code){
                if(code === 0){
                    return '门诊'
                }else if(code === 1){
                    return '住院'
                }else if(code === 2){
                    return '体检'
                }
            },
            getDetailByVisitingNo(no) {
                this.getDetailByVNoAsync(no)
                    .then(res => {
                        this.$emit('getDetail',res.retValue)
                    })
            },
            async getDetailByVNoAsync(no) {
                let request = new RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail()
                request.p_visitingNo = no
                await request.send()
                return request.result
            }
        }
    }
</script>

<style scoped lang="scss">
    .page-container{
        width:100%;
        min-height:160px;
        background:rgba(255,255,255,1);
        margin-bottom:20px;
        overflow-x: hidden;
        .medical-box{
            width: 95%;
            margin: 10px auto;
            border:1px solid rgba(0,0,0,0.03);
            box-shadow:0px 0px 8px 0px rgba(0,0,0,0.16),0px 0px 2px 0px rgba(0,0,0,0.3);
            border-radius:10px;
            /*box-sizing: border-box;*/
            .medical-info{
                width: 100%;
                background-color: #fafaff;
                /*box-shadow:0px 1px 0px 0px rgba(0,0,0,0.08);*/
                border-top-right-radius: 10px;
                border-top-left-radius: 10px;
                section{
                    display: flex;
                    justify-content:space-between;
                    width: 93%;
                    height: 50px;
                    align-items: center;
                    padding-left: 20px;
                    div{
                            color: #666;
                            font-size: 16px;
                    }
                }
                .medical-type{
                    color: #248cfa;
                }
            }
            .medical-inspect{
                cursor: pointer;
                background-color: white;
                padding: 10px;
                font-size: 15px;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                .label{
                    font-size:12px;
                    font-weight: 600;
                    text-align: left;
                }
                .line{
                    line-height: 15px;
                    width: 100%;
                    display: flex;
                    font-size: 12px;
                    justify-content: space-between;
                }
                .noLine{
                    width: 97%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    margin-top: 6px;
                    span{
                        width: 85%;
                        &:last-child{
                            text-align: justify;
                            line-height: 22px;
                            display: flex;
                            flex-wrap: wrap;
                            b{
                                display: inline-block;
                                background-color: rgba(36,140,250,0.85);
                                color: #fff;
                                border-radius: 5px;
                                padding: 2.5px 3px;
                                margin-left: 10px;
                                margin-top: 8px;
                            }
                        }

                    }

                }
            }
        }

    }
</style>
